import { styled } from '@mui/material';

export const PsSelectTunerBoxStyled = styled('div')({
  marginBottom: '2.5rem',
});
